const pathname = window.location.pathname
const pathProForecastId = pathname.split('/').pop()

export default () => {
  let pro_forecast_id;

  // use for dev
  if (pathname.indexOf('/pro-forecast-') > -1) {
    // pro_forecast_id = 73
    // pro_forecast_id = 56
    pro_forecast_id = 70
    // pro_forecast_id = 2 // San Francisco (Multiple daily updates)
    // pro_forecast_id = 94 // Texas
    // pro_forecast_id = 59
  }

  if (pathname.indexOf('/proforecast/') > -1) {
    pro_forecast_id = pathProForecastId
  }
  return {
    pro_forecast_id
  }
}
